import React from "react";
import PropTypes from "prop-types";
import "../styles/community.css";

/**
 * Community
 *
 * Figma-aligned testimonials section:
 * - Paddings: L/R 109, T/B 78
 * - Background: white
 * - Decorative absolute image on the right (behind cards)
 * - Centered title
 * - 3 testimonial cards (image on top, quote, name + role)
 *
 * A11y:
 * - <h2> section heading
 * - Testimonials rendered as <ul><li>; images have alt text
 */
const Community = ({
  title = "What Our Community Says",
  decorImage = "/media/dark-sage-leaf.png",
  testimonials = [
    {
      image: "/media/Celeste.png",
      quote:
        "“It’s helped me with my confidence a lot. I feel like I can talk and be who I am without feeling judged.”",
      name: "Celeste",
      role: "Student",
      imageAlt: "Student Celeste",
    },
    {
      image: "/media/Stephanie.png",
      quote:
        "“We’re not ticking boxes here. We’re connecting with students and giving them what they need.”",
      name: "Stephanie",
      role: "Teacher",
      imageAlt: "Teacher Stephanie",
    },
    {
      image: "/media/Geoff.png",
      quote:
        "“The Avenue has continued what The Cottage started—helping my daughter re-engage with school.”",
      name: "Geoff",
      role: "Parent",
      imageAlt: "Parent Geoff",
    },
  ],
}) => {
  return (
    <section className="comm-section">
      {/* Decorative image (behind cards) */}
      <img
        className="comm-decor"
        src={decorImage}
        alt=""
        aria-hidden="true"
      />

      {/* Heading */}
      <h2 className="comm-title">{title}</h2>

      {/* Cards */}
      <ul className="comm-row" role="list">
        {testimonials.map((t, i) => (
          <li key={i} className="comm-card">
            <img
              className="comm-card-img"
              src={t.image}
              alt={t.imageAlt || ""}
            />
            <blockquote className="comm-quote">{t.quote}</blockquote>
            <p className="comm-name">{t.name}</p>
            <p className="comm-role">{t.role}</p>
          </li>
        ))}
      </ul>
    </section>
  );
};

Community.propTypes = {
  title: PropTypes.string,
  decorImage: PropTypes.string,
  testimonials: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      imageAlt: PropTypes.string,
      quote: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
    })
  ),
};

export default Community;
